import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  dismiss() {
    this.animateOutCSS("fade-out").then(() => {
      this.element.remove()
    });
  }

  animateOutCSS(animation) {
    // We create a Promise and return it
    return new Promise((resolve, _reject) => {
      const animationName = animation;
      const node = this.element;
      node.classList.add(animationName);

      // When the animation ends, we clean the classes and resolve the Promise
      function handleAnimationEnd(event) {
        event.stopPropagation();
        node.classList.remove(animationName);
        resolve("Animation ended");
      }

      node.addEventListener("animationend", handleAnimationEnd);
    });
  }
}
